import script from "./testDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./testDetail.vue?vue&type=script&setup=true&lang=js"

import "./testDetail.vue?vue&type=style&index=0&id=9b9f6f44&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b9f6f44"]])

export default __exports__